import React from 'react'
import PropTypes from 'prop-types'
import styles from './../style/Cards1.module.scss'
import { Container, Image } from 'react-bootstrap'
import WhiteBlockTitle from './WhiteBlockTitle'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox' // Импортируем компонент

class Cards1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lightboxController: {
        toggler: false,
        slide: 1
      },
      lightboxImages: []
    }
  }

  // Функция для открытия лайтбокса с изображением
  openLightbox = (imageSrc, index = 0) => {
    const { list } = this.props
    // Собираем все изображения из списка
    const allImages = list.map(item => item?.image).filter(img => img)
    
    // Находим индекс выбранного изображения в общем массиве
    const imageIndex = allImages.findIndex(img => img === imageSrc)
    
    this.setState({
      lightboxImages: allImages,
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: (imageIndex !== -1 ? imageIndex : index) + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { list, title, rtext, text } = this.props
    const { lightboxController, lightboxImages } = this.state

    return (
      <section className={`${styles.section} ${styles.top}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
              className={styles.title}
            />
          }
          {text != `` &&
            <div className={styles.text}>{text}</div>
          }
          
          {/* Lightbox компонент */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={lightboxImages}
            slide={lightboxController.slide}
          />
          
          <div className={`${styles.list} ${styles[`grid-4`]} ${styles[`list_mob_scroll`]}`}>
            {list.map( ( elm, k ) => (
              <div key={k} className={`${styles.block} ${styles[`bg-1`]} ${styles[`h-130`]}`}>
                <Image 
                  className={styles.b_topimg} 
                  src={elm?.image} 
                  width={247} 
                  height={185} 
                  alt={elm?.name}
                  onClick={() => this.openLightbox(elm?.image, k)}
                  style={{ cursor: 'pointer' }}
                />
                <div className={styles.b_title}>
                  <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                  <div>{this.formatSlideNumber(k)}</div>
                </div>
                <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
              </div>
            ))}
          </div>
        </Container>
      </section>
    )
  }
}

Cards1.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  rtext: PropTypes.string,
  text: PropTypes.string
}

Cards1.defaultProps = {
  list: [],
  title: ``,
  text: ``
}

export default Cards1